
import { Component, Vue } from 'vue-property-decorator';
import Authenticator from '@/Services/Auth/Authenticator';
import { User } from '@/classes/auth';

@Component({})
export default class EnterprisePlan extends Vue {
  user: User = Authenticator.getUser();
  get returnMailTo(): string {
    return this.mailTo({
      emails: 'support@qr-code-generator.com',
      subject: `Enterprise Plan request (Customer ID: app-u-${this.user.id})`,
    });
  }

  mailTo({ emails, subject, body }: { emails: string; subject?: string; body?: string }): string {
    let mail = `mailto:${emails}`;
    if (!emails) {
      console.warn('mailTo is missing an email.');
    }
    if (subject) {
      mail += `?subject=${encodeURIComponent(subject)}`;
    }
    if (body) {
      mail += `${!subject ? '?' : '&'}body=${encodeURIComponent(body)}`;
    }
    return mail;
  }
}
